import React from "react";

export type SqlFileIconProps = React.ComponentProps<"svg">;

export const SqlFileIcon: React.FC<SqlFileIconProps> = ({
  className = "h-[14px] w-[14px]",
  style,
  ...props
}) => {
  const fill = /(^|\s)!?text-/.test(className) ? "currentColor" : "#6B7280";

  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      role="presentation"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: "inline-block", flexShrink: 0, ...style }}
    >
      <g>
        <g fill="currentColor">
          <path d="M3 12.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V12h1v.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5V12h1z"></path>
          <path
            fillRule="evenodd"
            d="M8.534 5.441q.728 0 1.258.315.533.315.823.895.291.582.291 1.378v.007q0 .796-.29 1.377a2.15 2.15 0 0 1-.535.691l.664.885h-.96l-.376-.5a2.7 2.7 0 0 1-.875.138q-.732 0-1.264-.315a2.13 2.13 0 0 1-.825-.899q-.287-.58-.287-1.377V8.03q0-.8.291-1.378.294-.581.827-.895.534-.315 1.258-.315m0 .875q-.4 0-.697.212a1.35 1.35 0 0 0-.462.595 2.3 2.3 0 0 0-.164.906v.007q0 .52.161.905.164.387.458.599.297.212.704.212c.104 0 .2-.016.294-.037L8.2 8.877h.96l.319.425q.124-.156.211-.36.164-.387.165-.906V8.03q0-.522-.165-.906a1.33 1.33 0 0 0-.458-.595 1.17 1.17 0 0 0-.697-.212"
            clipRule="evenodd"
          />
          <path d="M3.687 5.441q.573 0 .984.189.414.184.646.509.233.322.263.735l.004.044h-.97l-.008-.041a.6.6 0 0 0-.15-.31.8.8 0 0 0-.314-.21 1.2 1.2 0 0 0-.455-.078q-.253 0-.445.075a.7.7 0 0 0-.297.212.5.5 0 0 0-.106.318v.004q0 .239.191.392.195.15.63.24l.523.106q.523.105.85.287.332.18.49.454t.157.66v.003q0 .49-.243.848-.24.356-.687.554-.445.195-1.06.195a2.7 2.7 0 0 1-1.022-.178 1.6 1.6 0 0 1-.684-.499 1.4 1.4 0 0 1-.276-.762l-.004-.055H2.7l.003.034a.56.56 0 0 0 .15.325.9.9 0 0 0 .356.215q.222.079.51.08.276 0 .485-.083a.8.8 0 0 0 .324-.225q.12-.147.12-.335V9.14a.46.46 0 0 0-.198-.39q-.195-.147-.656-.242l-.52-.107q-.768-.156-1.118-.515-.348-.36-.348-.92v-.003q0-.458.243-.8.242-.342.666-.53.423-.192.97-.192m8.952 4.209h2.194v.85h-3.227V5.568h1.033zM12.5 2A1.5 1.5 0 0 1 14 3.5V4h-1v-.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V4H2v-.5A1.5 1.5 0 0 1 3.5 2z" />
        </g>
      </g>
    </svg>
  );
};
